import { mapState, mapMutations, mapActions } from 'vuex';
export const XTH_TYPE_KONG = '(空)';
export const initTopicBoxMixins = {
  data() {
    return {};
  },
  computed: {
    ...mapState('card', {
      subjects: state => state.subjects,
    }),
  },
  methods: {
    ...mapMutations({}),
    // 所有试题添加完之后初始化
    // 起始题号最好是当前最后一个题号+1
    clearHistoryTopicFormData(from) {
      if (from == 'creatItems') {
        // 是从题型弹窗编辑creatItems方法触发
        this.formData.start =
          this.formData.xTHValue == XTH_TYPE_KONG || this.formData.xTHValue === undefined
            ? Number(this.formData.end) + 1
            : Number(this.formData.start) + 1;
        this.formData.xTHValue && (this.formData.xTHValue = XTH_TYPE_KONG);
      } else {
        // 是从watch监听方法触发
        const end =
          this.subjects[this.subjects.length - 1] &&
          (this.subjects[this.subjects.length - 1].end ||
            this.subjects[this.subjects.length - 1].start);
        this.formData.start = (end && Number(end) + 1) || 1;
      }
      this.formData.optionNum = undefined;
      this.formData.end = undefined;
      this.formData.score = undefined;
      this.formData.tCount = undefined;
    },
  },
};
